export default __webpack_public_path__ + "static/media/print_icon.08abb412.svg";